import { useNavigate } from 'react-router-dom';
import Buttons from '../../../components/Buttons';
import '../styles/CallToAction.css';

const CallToAction = () => {

    function openMaps() {
        window.open("https://maps.app.goo.gl/fHfM5MR57w5mhEdV8", "_blank")
    }

    const navigate = useNavigate();
    function bookNow() {
        navigate("/booking");
    }

    return (
        <div className="call-to-action">
            <h2>Ready, Explorer?</h2>
            <p>Pack your sense of wonder and join us on this extraordinary adventure. Edakkal awaits the tread of your eager feet. Dive headfirst into the past - the caves are calling.</p>
            <Buttons color={true} firstText={"Open Maps"} secondText={"Book Tickets"} firstClicked={openMaps} secondClicked={bookNow} />
        </div>
    );
}

export default CallToAction;